export function networkErrorInterceptor(client) {
  client.interceptors.response.use(
    response => response,
    error => {
      console.log('[networkErrorInterceptor] Processing error:', {
        error: error,
        message: error?.message,
        code: error?.code,
        status: error?.response?.status,
        hasRequest: !!error.request,
        hasResponse: !!error.response,
        isOnline: navigator.onLine,
      })

      // Check if it's a network error
      if (
        error.code === 'ERR_NETWORK' ||
        error.code === 'NETWORK_ERROR' ||
        error.message === 'Network Error' ||
        !navigator.onLine ||
        (error.request && !error.response)
      ) {
        console.log('[networkErrorInterceptor] network error detected')
        // Dispatch a custom event for network error
        window.dispatchEvent(
          new CustomEvent('network-error', {
            detail: { error, timestamp: Date.now() },
          }),
        )
      } else {
        console.log('[networkErrorInterceptor] Not a network error, passing through')
      }

      return Promise.reject(error)
    },
  )
}
